<template>
  <div id="plans-launchpad">
    <Hero v-bind:title="'Plan: ' + plan.name" v-bind:planTheme="plan.theme">
      <h2 v-if="planAdmin">{{ plan.description }}</h2>
      <a
        v-if="planAdmin && plan.enabled"
        v-on:click.prevent="showModal = true"
        class="button"
        href="#"
        >{{ $t("views.plan.button.create") }}</a
      >
      <Modal
        v-if="showModal"
        v-bind:modalTitle="$t('views.plan.modal.header')"
        v-on:close="showModal = false"
      >
        <p>{{ $t("views.plan.modal.text") }}:</p>
        <GroupForm v-bind:planId="plan.id" />
      </Modal>
      <TabNav v-if="planAdmin" v-bind:menu="tabMenu" />
    </Hero>

    <section id="plan-content">
      <Breadcrumb v-bind:crumbs="breadcrumbs" />
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
import Hero from "@/components/plans/Hero.vue";
import Modal from "@/components/Modal.vue";
import GroupForm from "@/components/plan/GroupForm.vue";
import TabNav from "@/components/TabNav.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

import { planService } from "@/services/plan.service";
import { groupService } from "@/services/group.service";

export default {
  name: "Plan",
  components: {
    Hero,
    Modal,
    GroupForm,
    TabNav,
    Breadcrumb,
  },
  data() {
    return {
      planAdmin: true,
      showModal: false,
      planId: Number,
      plan: {},
      tabMenu: [
        {
          name: "Plan",
          link: "/plan/" + this.$route.params.planId,
        },
        {
          name: this.$t("views.plan.tab.history"),
          link: "/plan/" + this.$route.params.planId + "/history",
        },
        {
          name: this.$t("views.plan.tab.edit"),
          link: "/plan/" + this.$route.params.planId + "/edit",
        },
        {
          name: this.$t("views.plan.tab.archived"),
          link: "/plan/" + this.$route.params.planId + "/archive",
        },
      ],
      breadcrumbs: [],
    };
  },
  created: function () {
    this.planId = this.$route.params.planId;
    this.checkWhitelistAccess();
  },
  methods: {
    fetchPlan: function () {
      // grab the plan
      planService
        .getPlan(this.$route.params.planId)
        .then((plan) => {
          this.plan = plan;
          if (plan.description) {
            this.plan.description = decodeURIComponent(atob(plan.description));
          }

          this.pushBreadcrumb();
        })
        .catch((err) => {
          this.planAdmin = false;
          planService.getPlanByMember(this.planId).then((plan) => {
            this.plan.theme = plan.theme;
          });

          if (err == "User does not have permission for plan") {
            this.ownGroups();
          } else {
            console.error("Something went wrong fetching plan: ", err);
            this.$router.push("/plans");
          }
        });
    },
    ownGroups: function () {
      groupService
        .getGroups()
        .then((groups) => {
          this.parseMemberGroups(groups);
        })
        .catch((err) => {
          console.error("Something went wrong fetching own groups: ", err);
        });
    },
    parseMemberGroups: function (groups) {
      for (let group of groups) {
        if (group.planId === Number(this.planId)) {
          this.plan.name = group.planName;
          this.pushBreadcrumb();
          this.$forceUpdate();
        }
      }
      if (!this.plan.name) {
        this.$router.push("/plans");
      }
    },
    pushBreadcrumb: function () {
      // Build up the Breadcrumb
      this.breadcrumbs.push({
        name: this.plan.name,
      });
    },
    checkWhitelistAccess: function () {
      planService.whitelistAccess(this.$route.params.planId).then((res) => {
        if (res) {
          this.fetchPlan();
        } else {
          this.$router.push("/error?err=403");
        }
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (from.path === "/plan/" + this.$route.params.planId + "/edit") {
      this.breadcrumbs = [];
      this.fetchPlan();
    }
    next();
  },
};
</script>

<style lang="scss">
.content-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 70px;
}
</style>
